import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";

export const RankingMainViewFilterPanel = () => {
    return (
        <div css={rankingFilterPanel}>
            <Text as="p" css={mb(3)} variant="headline_5">
                Sprawdź ulubione oferty naszych użytkowników!
            </Text>

            <OfferRankingForm />
        </div>
    );
};

const rankingFilterPanel = (theme: Theme) => css`
    background-color: #fff;
    ${borderRadius(2)};
    ${p(4, 2)};
    ${elevation(4)};

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 45.3rem;
        ${p(4, 3)};
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, mb, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {OfferRankingForm} from "../offer_ranking_form/OfferRankingForm";

export const RankingMainViewFilterPanel = () => {
    return (
        <div css={rankingFilterPanel}>
            <Text as="p" css={mb(3)} variant="headline_5">
                Sprawdź ulubione oferty naszych użytkowników!
            </Text>

            <OfferRankingForm />
        </div>
    );
};

const rankingFilterPanel = (theme: Theme) => css`
    background-color: #fff;
    ${borderRadius(2)};
    ${p(4, 2)};
    ${elevation(4)};

    @media (min-width: ${theme.breakpoints.md}) {
        max-width: 45.3rem;
        ${p(4, 3)};
    }
`;
